module.exports = __webpack_public_path__ + "static/media/icon-arrow-right.7388b43d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-arrow-right.svg
// module id = 644
// module chunks = 0